import React from 'react';

const Policy: React.FC = () => {
  return (
    <div className="m-5">
      <p>
        <b>
          <span>Privacy Statement of World Gem Trade Inc.</span>
        </b>
      </p>

      <p>
        <b>
          <span>Information about our Organization and Web site</span>
        </b>
      </p>

      <p>
        <span>
          Modern information and communication technologies play a fundamental
          role in the activities of an organization like World Gem Trade Inc.
        </span>
      </p>

      <p>
        <span>We are based in Canada.</span>
      </p>

      <p>
        <span>
          Our principal activity is: Electronic Jewelry Inventory Procurement
          for the Jewelry Industry
        </span>
      </p>

      <p>
        <span>
          Our privacy policy covers World Gem Trade Inc. and its Web site:{' '}
          <u>
            <span>
              <a
                href="http://www.worldgemtrade.com"
                target="_blank"
                rel="noreferrer"
              >
                www.worldgemtrade.com
              </a>
            </span>
          </u>
        </span>
      </p>

      <p>
        <b>
          <span>Organization Name:</span>
        </b>
        <span>
          {' '}
          World Gem Trade Inc.
          <br />
          <b>Address:</b> 8605 Santa Monica Blvd #89281
          <br />
          <b>City, Zip Code:</b> Los Angeles, 90069-4109
          <br />
          <b>State:</b> California
          <br />
          <b>Country:</b> United States of America
          <br />
          <b>Web Sites(s):</b> www.worldgemtrade.com
        </span>
      </p>

      <p>
        <b>
          <span>The services and links of our Web site</span>
        </b>
      </p>

      <p>
        <span>
          Our Web site enables you to communicate with other visitors or to post
          information to be accessed by others. When you do so, other visitors
          may collect your communicated data.
        </span>
      </p>

      <p>
        <span>
          Our Web site does not include links to third party Web service
          providers.
        </span>
      </p>

      <p>
        <b>
          <span>Automatic Collection of Information</span>
        </b>
      </p>

      <p>
        <span>We do not use cookies on our Web site.</span>
      </p>

      <p>
        <span>
          We do not automatically log personal data nor do we link information
          automatically logged by other means with personal data about specific
          individuals.
        </span>
      </p>

      <p>
        <b>
          <span>Data Collection and Purpose Specification</span>
        </b>
      </p>

      <p>
        <span>
          We collect the personal data that you may volunteer while using our
          services.
        </span>
      </p>

      <p>
        <span>
          We do not collect information about our visitors from other sources,
          such as public records or bodies, or private organizations.
        </span>
      </p>

      <p>
        <span>
          We do not collect or use personal data for any purpose other than that
          indicated in the table below.
        </span>
      </p>

      <p>
        <span>
          If we wish to use your personal data for a new purpose, we offer you
          the means to consent to this new purpose: email{' '}
          <u>
            <span>
              <a href="mailto:info@worldgemtrade.com">info@worldgemtrade.com</a>
            </span>
          </u>
        </span>
      </p>

      <p>
        <b>
          <span>Children`s Privacy</span>
        </b>
      </p>

      <p>
        <span>
          World Gem Trade is a business oriented website, and we do not
          knowingly collect personal data from children.
        </span>
      </p>

      <p>
        <span>
          We do not take specific steps to protect the privacy of children who
          disclose their personal data to us.
        </span>
      </p>

      <p>
        <span>
          We do not provide information about our personal data practices in
          relation to children on our home page, or at those sites on our Web
          site where we collect personal data.
        </span>
      </p>

      <p>
        <b>
          <span>Disclosure and Visitor Choice</span>
        </b>
      </p>

      <p>
        <span>
          We do not disclose your personal data to our subsidiaries or other
          organizations.
        </span>
      </p>

      <p>
        <b>
          <span>Confidentiality / Security</span>
        </b>
      </p>

      <p>
        <span>
          We do not give visitors to our Web site the option of using a secure
          transmission method to send us their personal data.
        </span>
      </p>

      <p>
        <span>
          We have implemented security policies, rules and technical measures to
          protect the personal data that we have under our control from:
        </span>
      </p>

      <ul>
        <li>
          <span>unauthorized access</span>
        </li>
        <li>
          <span>improper use or disclosure</span>
        </li>
      </ul>

      <p>
        <span>
          We have not implemented security policies, rules and technical
          measures to protect the personal data that we have under our control
          from:
        </span>
      </p>

      <ul>
        <li>
          <span>unauthorized modification</span>
        </li>
        <li>
          <span>unlawful destruction or accidental loss</span>
        </li>
      </ul>

      <p>
        <span>
          All our employees and data processors, who have access to, and are
          associated with the processing of personal data, are obliged to
          respect the confidentiality of our visitors` personal data.
        </span>
      </p>

      <p>
        <span>
          We ensure that your personal data will not be disclosed to State
          institutions and authorities except if required by law or other
          regulation.
        </span>
      </p>

      <p>
        <b>
          <span>Access to the personal data we may hold about you</span>
        </b>
      </p>

      <p>
        <span>
          You can ask us, by: sending an email to{' '}
          <u>
            <span>
              <a href="mailto:info@worldgemtrade.com">info@worldgemtrade.com</a>
            </span>
          </u>
          whether we are keeping personal data about you.
        </span>
      </p>

      <p>
        <span>
          Upon request, which you can indicate by: sending an email to{' '}
          <u>
            <span>
              <a href="mailto:info@worldgemtrade.com">info@worldgemtrade.com</a>
            </span>
          </u>
          . We will provide you with a readable copy of the personal data which
          we keep about you, within a week. - although we may before require
          proof of your identity -. We will provide the information without any
          charge.
        </span>
      </p>

      <p>
        <span>
          We allow you to challenge the data that we hold about you and, where
          appropriate, you may have the data:
        </span>
      </p>

      <ul>
        <li>
          <span>erased</span>
        </li>
        <li>
          <span>rectified or amended</span>
        </li>
        <li>
          <span>completed</span>
        </li>
      </ul>

      <p>
        <span>
          We do not reserve the right to refuse to provide you with a copy of
          your personal data.
        </span>
      </p>

      <p>
        <span>Privacy Compliance</span>
      </p>

      <p>
        <span>
          There are no national laws or self-regulatory schemes applicable to
          our web site or organization.
        </span>
      </p>

      <p>
        <span>
          There are no global or regional regulatory or self-regulatory schemes
          applicable to our web site or organization.
        </span>
      </p>

      <p>
        <span>
          We cannot demonstrate that our privacy policy accords with the privacy
          instrument.
        </span>
      </p>

      <p>
        <b>
          <span>Privacy Support</span>
        </b>
      </p>

      <p>
        <span>
          If you have an enquiry or concern about our privacy policy, please
          contact:{' '}
          <u>
            <span>
              <a href="mailto:info@worldgemtrade.com">info@worldgemtrade.com</a>
            </span>
          </u>
        </span>
      </p>

      <p>
        <a>
          <b>
            <span>
              TABLE of personal data collected and purposes for which they are
              used
            </span>
          </b>
        </a>
      </p>

      <p>
        <b>
          <span>Primary personal data/Business information</span>
        </b>
      </p>

      <ul>
        <li>
          <span>volunteered by each visitor</span>
        </li>
        <li>
          <span>collected from public records or bodies</span>
        </li>
        <li>
          <span>collected from private organizations</span>
        </li>
      </ul>

      <p>
        <a>
          <b>
            <span>Primary personal data</span>
          </b>
        </a>
      </p>

      <table>
        <thead>
          <tr>
            <td width="200" />
            <td width="4%">
              <p>
                <b>
                  <span>Technical administration of the Web site</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>Research &amp;development</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>Customer Administration</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>Marketing</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>Trading in personal data</span>
                </b>
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Name</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Gender</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Address</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>E-mail address</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Phone/Fax number</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <b>
                  <span>other</span>
                </b>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
            <td>
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        <b>
          <span>Business Information</span>
        </b>
      </p>

      <table>
        <thead>
          <tr>
            <td width="200" />
            <td width="87">
              <p>
                <b>
                  <span>Technical administration of the Web site</span>
                </b>
              </p>
            </td>
            <td width="94">
              <p>
                <b>
                  <span>Research &amp; development</span>
                </b>
              </p>
            </td>
            <td width="106">
              <p>
                <b>
                  <span>Customer Administration</span>
                </b>
              </p>
            </td>
            <td width="63">
              <p>
                <b>
                  <span>Marketing</span>
                </b>
              </p>
            </td>
            <td width="77">
              <p>
                <b>
                  <span>Trading in personal data</span>
                </b>
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Employer/organisation</span>
                </b>
              </p>
            </td>
            <td width="87">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="94">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="106">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="63">
              <p>
                <b>
                  <span>-</span>
                </b>
              </p>
            </td>
            <td width="77">
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Job title</span>
                </b>
              </p>
            </td>
            <td width="87">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="94">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="106">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="63">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="77">
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Address</span>
                </b>
              </p>
            </td>
            <td width="87">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="94">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="106">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="63">
              <p>
                <b>
                  <span>-</span>
                </b>
              </p>
            </td>
            <td width="77">
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>E-mail address</span>
                </b>
              </p>
            </td>
            <td width="87">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="94">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="106">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="63">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="77">
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>Phone/Fax number</span>
                </b>
              </p>
            </td>
            <td width="87">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="94">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="106">
              <p>
                <b>
                  <span>x</span>
                </b>
              </p>
            </td>
            <td width="63">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="77">
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>
                <b>
                  <span>other</span>
                </b>
              </p>
            </td>
            <td width="87">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="94">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="106">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="63">
              <p>
                <span>-</span>
              </p>
            </td>
            <td width="77">
              <p>
                <span>-</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <p>&nbsp;</p>
    </div>
  );
};

export default Policy;
